import z from "zod";

export const videoRecorderFormSchema = z.object({
	title: z.string(),
	description: z.string().optional(),
});

export type VideoRecorderFormSchema = z.infer<typeof videoRecorderFormSchema>;
